// import React from 'react';
// import styled from 'styled-components';
// import { Fade } from 'react-awesome-reveal';
// import KidsCodeAndTechPage from './KidsCodeAndTechPage';
// import KidsCodePageHero from './KidsCodePageHero';
// import kd01 from '../Images/kd01.png'

// const PageContainer = styled.div`
//   background-color: #ffffff;
//   color: #1a1a1a;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//   overflow-x: hidden;
//   padding: 0;
//   margin: 0;
//   width: 100%;
//   margin-top:50px;
// `;

// const Section = styled.section`
//   padding: 10px;
//   margin: 10px auto;
//   max-width: 1200px;
// `;

// const HeroSection = styled(Section)`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   gap: 10px;
//   padding: 10px;
// `;

// const Title = styled.h1`
//   font-size: 32px;
//   color: #111827;
//   margin: 0 0 10px 0;
//   line-height: 1.2;
//   word-break: break-word;
// `;

// const Subtitle = styled.p`
//   font-size: 16px;
//   color: #4b5563;
//   margin: 0 0 10px 0;
//   max-width: 700px;
//   word-break: break-word;
// `;

// const Button = styled.button`
//   background-color: #4f46e5;
//   color: #ffffff;
//   border: none;
//   padding: 8px 16px;
//   font-size: 14px;
//   font-weight: 600;
//   border-radius: 4px;
//   cursor: pointer;
//   margin: 5px;
//   transition: background 0.2s;

//   &:hover {
//     background-color: #4338ca;
//   }
// `;

// const StyledImage = styled.img`
//   width: 100%;
//   height: 250px;
//   object-fit: cover;
//   border-radius: 6px;
//   border: 1px solid #e5e7eb;
// `;

// const CardGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 10px;
//   margin: 10px 0;
// `;

// const Card = styled.div`
//   background: #ffffff;
//   border: 1px solid #e5e7eb;
//   padding: 10px;
//   border-radius: 6px;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
// `;

// const CardTitle = styled.h3`
//   font-size: 18px;
//   color: #1f2937;
//   margin: 0;
// `;

// const CardText = styled.p`
//   font-size: 14px;
//   color: #4b5563;
//   margin: 0;
//   word-break: break-word;
// `;

// const SectionHeader = styled.h2`
//   font-size: 26px;
//   background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   text-align: center;
//   margin: 12px 0;
//   font-weight: 800;
//   letter-spacing: -0.5px;
//   filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.08));
// `;

// export default function SummerCodingPage() {
//   return (
// <PageContainer>
//         <KidsCodePageHero/>
//       <Fade triggerOnce>
//         <HeroSection>
//           <Title>Exciting Summer Coding & AI Camp for Kids & Teens</Title>
//           <Subtitle>Transform your child's holiday into an adventure of creation, artificial intelligence, logic, and tech innovation. Designed for ages 6–16.</Subtitle>
//           <Button>Secure Your Slot Now</Button>
//           <StyledImage src={kd01} alt="Summer coding and AI camp kids" />
//         </HeroSection>
//       </Fade>

//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>What Kids Will Build This Summer</SectionHeader>
//           <CardGrid>
//             <Card>
//               <CardTitle>Interactive Games & AI Models</CardTitle>
//               <CardText>Students learn game physics, character design, and intelligent machine learning logic to build playable games and smart tools from scratch.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Mobile & Web Apps</CardTitle>
//               <CardText>Empower young creators to design responsive web pages and simple mobile applications tackling real-world needs.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Robotics & Artificial Intelligence</CardTitle>
//               <CardText>Blend code with physical computing and smart AI algorithms to bring automated robots, prompt systems, and gadgets to life.</CardText>
//             </Card>
//           </CardGrid>
//         </Section>
//       </Fade>

//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>Camp Highlights & Schedule Structure</SectionHeader>
//           <CardGrid>
//             <Card>
//               <CardTitle>Hands-On Projects Daily</CardTitle>
//               <CardText>Zero boring lectures. Every session centers around building a functional tech or AI project that kids can showcase.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Flexible Learning Options</CardTitle>
//               <CardText>Available in both immersive onsite classroom cohorts and interactive live online instructor-led formats.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Final Demo Day</CardTitle>
//               <CardText>Parents and peers are invited to a special exhibition where students present their custom-built coding and AI innovations.</CardText>
//             </Card>
//           </CardGrid>
//         </Section>
//       </Fade>

//       <Fade triggerOnce>
//         <Section style={{ textAlign: 'center', background: '#f8f9fa', padding: '20px', borderRadius: '6px' }}>
//           <SectionHeader>Give Your Child a Head Start This Summer</SectionHeader>
//           <Subtitle style={{ margin: '0 auto 10px auto' }}>
//             Spaces are limited per cohort to ensure personalized attention from our expert instructors. Register today!
//           </Subtitle>
//           <Button>Enroll in Summer Coding & AI</Button>
//         </Section>
//       </Fade>
//     </PageContainer>
//   );
// }





import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import KidsCodeAndTechPage from './KidsCodeAndTechPage';
import KidsCodePageHero from './KidsCodePageHero';
import kd01 from '../Images/kd01.png';
import { useNavigate } from 'react-router-dom';
import ProgramPricing from './ProgramPricing';

const PageContainer = styled.div`
  background-color: #fafbfc;
  color: #1a1a1a;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
  margin-top: 50px;
`;

const Section = styled.section`
  padding: 16px;
  margin: 16px auto;
  max-width: 1200px;
`;

const HeroSection = styled(Section)`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  align-items: center;
  gap: 24px;
  padding: 24px 16px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
  font-weight: 800;
  word-break: break-word;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #475569;
  margin: 0;
  line-height: 1.5;
  word-break: break-word;
`;

const Button = styled.button`
  background-color: #4f46e5;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2);

  &:hover {
    background-color: #4338ca;
    transform: translateY(-2px);
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 280px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

const SplitLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin: 16px 0;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border-top: 4px solid #4f46e5;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;

const CardTitle = styled.h3`
  font-size: 18px;
  color: #1e293b;
  margin: 0;
  font-weight: 700;
`;

const CardText = styled.p`
  font-size: 14px;
  color: #475569;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
`;

const SectionHeader = styled.h2`
  font-size: 26px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  margin: 24px 0 16px 0;
  font-weight: 800;
  letter-spacing: -0.5px;
`;

export default function SummerCodingPage() {
    const navigate  =useNavigate();
  return (
    <PageContainer>
      <KidsCodePageHero />
      
      <Fade triggerOnce>
        <HeroSection>
          <HeroContent>
            <Title>Exciting Summer Coding & AI Camp for Kids & Teens</Title>
            <Subtitle>Transform your child's holiday into an adventure of creation, artificial intelligence, logic, and tech innovation. Designed for ages 6–16.</Subtitle>
            <Button onClick={()=>navigate('/codingapplicationfaq')}>Secure Your Slot Now</Button>
          </HeroContent>
          <div>
            <StyledImage src={kd01} alt="Summer coding and AI camp kids" />
          </div>
        </HeroSection>
      </Fade>

      <Fade triggerOnce>
        <Section>
          <SectionHeader>What Kids Will Build This Summer</SectionHeader>
          <SplitLayout>
            <Card>
              <CardTitle>Interactive Games & AI Models</CardTitle>
              <CardText>Students learn game physics, character design, and intelligent machine learning logic to build playable games and smart tools from scratch.</CardText>
            </Card>
            <Card style={{ borderTopColor: '#06b6d4' }}>
              <CardTitle>Mobile & Web Apps</CardTitle>
              <CardText>Empower young creators to design responsive web pages and simple mobile applications tackling real-world needs.</CardText>
            </Card>
            <Card style={{ borderTopColor: '#10b981' }}>
              <CardTitle>Robotics & Artificial Intelligence</CardTitle>
              <CardText>Blend code with physical computing and smart AI algorithms to bring automated robots, prompt systems, and gadgets to life.</CardText>
            </Card>
          </SplitLayout>
        </Section>
      </Fade>

      <Fade triggerOnce>
        <Section>
          <SectionHeader>Camp Highlights & Schedule Structure</SectionHeader>
          <SplitLayout>
            <Card>
              <CardTitle>Hands-On Projects Daily</CardTitle>
              <CardText>Zero boring lectures. Every session centers around building a functional tech or AI project that kids can showcase.</CardText>
            </Card>
            <Card style={{ borderTopColor: '#06b6d4' }}>
              <CardTitle>Flexible Learning Options</CardTitle>
              <CardText>Available in both immersive onsite classroom cohorts and interactive live online instructor-led formats.</CardText>
            </Card>
            <Card style={{ borderTopColor: '#10b981' }}>
              <CardTitle>Final Demo Day</CardTitle>
              <CardText>Parents and peers are invited to a special exhibition where students present their custom-built coding and AI innovations.</CardText>
            </Card>
          </SplitLayout>
        </Section>
      </Fade>

      <Fade triggerOnce>
        <Section style={{ textAlign: 'center', background: '#ffffff', padding: '32px 20px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)' }}>
          <SectionHeader style={{ marginTop: 0 }}>Give Your Child a Head Start This Summer</SectionHeader>
          <Subtitle style={{ margin: '0 auto 20px auto', maxWidth: '650px' }}>
            Spaces are limited per cohort to ensure personalized attention from our expert instructors. Register today!
          </Subtitle>
          <Button onClick={()=>navigate('/codingapplicationfaq')}>Enroll in Summer Coding & AI</Button>
        </Section>
      </Fade>
      <ProgramPricing/>
    </PageContainer>
  );
}